import { MdOutlineWarning } from "react-icons/md";
import useInternetStatus from "../../Utils/useInternetStatus";

const InternetStatusToast = () => {
  const { status, speed } = useInternetStatus();

  if (status === "online") {
    return null;
  }

  const isOffline = status === "offline";
  const displayedSpeed = speed !== null
    ? speed < 0.01 ? "<0.01" : speed.toFixed(2)
    : null;

  return (
    <div
      className=" alert alert-danger mb-0 rounded-0 d-flex align-items-center gap-2 py-2 px-3 sticky-top border-0 border-bottom border-warning text-white"
      role="alert"
      aria-live="assertive"
    >
      <span className="text-warning fs-5 lh-1" aria-hidden="true"> <MdOutlineWarning/> </span>
      <span>
        {isOffline
          ? "Internet connection lost. Check your network and reconnect to continue."
          : `Your internet connection is slow. Some pages or actions may take longer to load.${displayedSpeed ? ` Current speed: ${displayedSpeed} Mbps.` : ""}`}
      </span>
    </div>
  );
};

export default InternetStatusToast;